import React, {useContext, useEffect, useState} from 'react'
import StoreContext from '../../context/store/StoreContext'
import HomeContext from '../../context/home/HomeContext'
import ItemContext from '../../context/item/ItemContext'
import {Spinner} from '../layout/Spinner'
import ListContext from '../../context/list/ListContext'
import NewListContent from './NewListContent'
import {useCurrentListHandler} from '../../utils/hooks'
import { withComponentLabel } from '../../utils/debug'

const NewListPage = ({store}) => {
  const storeContext = useContext(StoreContext)
  const homeContext = useContext(HomeContext)
  const itemContext = useContext(ItemContext)
  const listContext = useContext(ListContext)

  const {currentStore, clearCurrentStore} = storeContext
  const {homes, getHomes} = homeContext
  const {getItemsByHomeAndStore} = itemContext
  const {
    pushItemCurrentList,
    popItemCurrentList,
    currentList,
    addList,
    clearCurrentList,
  } = listContext

  const [currentHome, setCurrentHome] = useState(null)
  const [homeItems, setHomeItems] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const loadHomes = async () => {
      await getHomes()
      setLoading(false)
    }
    loadHomes()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // Set first home as current when homes load
    if (homes && homes.length > 0 && !currentHome) {
      setCurrentHome(homes[0])
    }
  }, [homes, currentHome])

  useEffect(() => {
    // Load items for current home and store
    const loadHomeItems = async () => {
      if (currentHome && currentStore) {
        const items = await getItemsByHomeAndStore(currentHome._id, currentStore._id)
        setHomeItems(items)
      }
    }
    loadHomeItems()
    // eslint-disable-next-line
  }, [currentHome, currentStore])

  const onSave = async (list) => {
    // Format items to match ListSchema structure
    const formattedList = {
      ...list,
      items: list.items.map(item => ({
        item: item._id,
        name: item.name,
        shopped: false,
        location: null // Can add location logic later for optimization
      }))
    }
    addList(formattedList)
    clearCurrentList()
    clearCurrentStore()
  }

  const [listHandler, saveHandler, listState] = useCurrentListHandler(
    currentList,
    {
      saveFunction: onSave,
      popFunction: popItemCurrentList,
      pushFunction: pushItemCurrentList,
    }
  )

  if (loading || !currentStore || !currentHome) {
    return <Spinner />
  }

  return (
    <>
      <div
        onClick={() => saveHandler(currentList)}
        className='fixed-action-btn'
      >
        <a
          className='btn-floating btn-large green modal-trigger'
          href='#saveModal'
        >
          <i className='large material-icons'>check</i>
        </a>
      </div>
      <div className='h-5 -mt-1 -mx-0.5 z-10 border-t-gray-200 border-x-2 rounded-t-2xl bg-orange-500'></div>
      <div className='bg-orange-500 rounded-b-full border-gray-300 shadow-lg shadow-orange-100 pb-4'>
        <div className='flex items-center justify-center'>
          <div className='flex-grow text-center text-white font-extrabold text-3xl tracking-widest'>
            {currentStore.name}
          </div>
        </div>
      </div>
      <div className='flex w-full mt-2 ml-2'>
        {homes.map((home, i) => (
          <div key={home._id}>
            <div
              onClick={() => setCurrentHome(home)}
              className={`rounded-t-lg border-x-2 mx-1 border-t-4 p-2 cursor-pointer ${
                home._id !== currentHome._id ? 'bg-slate-200' : 'bg-white'
              }`}
            >
              {home.name}
            </div>
          </div>
        ))}
      </div>
      <div className='flex-grow'>
        <NewListContent
          items={homeItems}
          home={currentHome.name}
          currentList={listState}
          clickHandler={listHandler}
        />
      </div>
    </>
  )
}

export default withComponentLabel(NewListPage, 'NewListPage')